module.exports = __webpack_public_path__ + "static/media/sanibel1909.d849fcb9.png";